import { Controller } from "@hotwired/stimulus"

// location -> Meta pixel event name. Kept in sync with the server-side
// CTA_EVENTS map in TrackingController so Meta, Segment, and Mixpanel all
// report the same event names.
const META_EVENTS = {
  hero:    'Button Click "Become A Store Owner" - Hero',
  nav:     'Button Click "Get Started" - Navigation',
  pricing: 'Button Click "Get Started" - Pricing',
  footer:  'Button Click "Become A Store Owner" - Footer'
}

// Fires an anonymous CTA-click analytics event when a marketing-page button is
// clicked, then lets the normal link navigation proceed. Fire-and-forget: we do
// not preventDefault and use keepalive so the request survives the navigation.
export default class extends Controller {
  static values = { location: String }

  track() {
    this.trackMeta()
    this.trackServer()
  }

  // Client-side Meta pixel event, mirroring the ScheduleDemo/CompleteRegistration
  // pattern. fbq is loaded globally by the marketing layout; guard in case the
  // pixel hasn't loaded yet.
  trackMeta() {
    const event = META_EVENTS[this.locationValue]
    if (event && typeof fbq === "function") fbq("trackCustom", event)
  }

  trackServer() {
    const csrf = document.querySelector('meta[name="csrf-token"]')?.content

    fetch("/track/cta", {
      method: "POST",
      keepalive: true,
      credentials: 'same-origin',
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": csrf || ""
      },
      body: JSON.stringify({ location: this.locationValue })
    }).catch(() => {
      // Tracking is best-effort; never block or break navigation on failure.
    })
  }
}
